import InputMask from 'react-input-mask';
import React from 'react';
import classnames from 'classnames';
import styles from './creditCard.module.scss';
import { SchemaParser } from '../../services';
import { store } from '../../../models';
import { SelectField } from '../../styleguide';
import { Paths } from '../../../constants';

const creditCard = ({
  props: {
    header,
    saveCheckbox,
    label,
    handleChange,
    paymentMethod,
    existingCards,
    handleAddNewCard,
    newCardForm,
    profileSettings,
    makeDefaultCheckBox,
    discard,
    inputMask,
    addNewCard,
    cardType,
    creditCard: { creditCardValid: isValid, name, number,expirationMonth,expirationYear, validation} = {},
    typeChecker,
    errors,
    paymentType,
    hideCreditCards,
    verification,
    setVerificationMask,
    guestMode,
    location: { pathname },
  },
}) =>
  (paymentMethod === 'creditCard' || !!profileSettings || guestMode) && (
    <div className={classnames({ [styles.hideContainer]: hideCreditCards })}>
      {!profileSettings && (
        <SchemaParser schema={[header.chooseCard]} />
      )}
      <div className={styles.paymentOptions}>
        {existingCards && <SchemaParser schema={[existingCards]} />}
      </div>
      {existingCards && !newCardForm && (
        <button className={styles.newCardBtn} onClick={handleAddNewCard}>
          {label.addNew}
        </button>
      )}
      {(!existingCards || newCardForm ) && (
        <div className={styles.newCardFormContainer}>
          {(existingCards || guestMode) && (
            <SchemaParser schema={[header.newCard]} />
          )}
          {errors &&
            errors.map(error => (
              <div key={error} className={styles.creditCardError}>
                {error}
              </div>
            ))}
          <div
            className={classnames(
              styles.creditContainer,
              styles.creditCardName,
            )}
          >
            {store.getState().settings.payment_required_bit?<label htmlFor="name" className={styles.label}>{label.nameOnCard}<span style={{ color: 'red' }}>*</span></label>:<label htmlFor="name" className={styles.label}>{label.nameOnCard}</label>}
            <div className={styles.inputWrapper}>
              <input
                id="name"
                onChange={handleChange}
                type="text"
                name="name"
                payeezy-data="cardholder_name"
                value={name}
              />
            </div>
          </div>
          <div className={styles.creditCardNumber}>
            {store.getState().settings.payment_required_bit?<label htmlFor="creditCard" className={styles.label}>{label.cardNumber}<span style={{ color: 'red' }}>*</span></label>:<label htmlFor="creditCard" className={styles.label}>{label.cardNumber}</label>}
            <div className={styles.numberContainer} data-private>
              <InputMask
                id="number"
                onChange={handleChange}
                mask={inputMask}
                maskChar={null}
                onBlur={e => typeChecker(e, 'onBlur')}
                payeezy-data="cc_number"
                value={number}
              />
              {cardType && <div className={styles.cardType}>{cardType}</div>}
            </div>
          </div>
          <div className={styles.validation}>
            <div className={styles.valcode} data-private>
              {store.getState().settings.payment_required_bit?<label htmlFor="validation" className={styles.label}>{label.validationCode}<span style={{ color: 'red' }}>*</span></label>:<label htmlFor="validation" className={styles.label}>{label.validationCode}</label>}
              <InputMask
                id="validation"
                onChange={handleChange}
                onFocus={setVerificationMask}
                name="validation"
                mask={verification}
                maskChar={null}
                payeezy-data="cvv_code"
                value={validation}
              />
            </div>
            <div className={styles.expiration}>
              {store.getState().settings.payment_required_bit ? (
                <label htmlFor="expiration" className={styles.label}>
                  {label.expirationDate}
                  <span style={{ color: 'red' }}>*</span>
                </label>
              ) : (
                <label htmlFor="expiration" className={styles.label}>
                  {label.expirationDate}
                </label>
              )}

              <div className={styles.dropDown}>
                <SelectField
                  name='expirationMonth'
                  options={Array.from({ length: 12 }, (_, i) => {
                    const monthNumber = String(i + 1).padStart(2, '0');
                    // const monthName = new Date(0, i % 12).toLocaleString('default', { month: 'long' });
                    return { value: monthNumber, name:monthNumber, label: monthNumber };
                  })}
                  value={expirationMonth}
                  onChange={handleChange}
                  placeholder="Month"
                />

                <SelectField
                  name='expirationYear'
                  options={Array.from({ length: 21 }, (_, i) => {
                    const year = new Date().getFullYear() + i;
                    const shortYear = year.toString().slice(-2);
                    return { label: year, name: shortYear, value: shortYear };
                  })}
                  value={expirationYear}
                  onChange={handleChange}
                  placeholder='Year'
                />
              </div>
            </div>

          </div>
          {saveCheckbox && (
            <SchemaParser
              schema={[
                { ...saveCheckbox, disabled: paymentType === 'paymentPlan' || pathname.endsWith(Paths.SCHEDULE_PAYMENT) },
              ]}
            />
          )}
          {makeDefaultCheckBox && (
            <SchemaParser schema={[makeDefaultCheckBox]} />
          )}
          {profileSettings && existingCards && (
            <SchemaParser schema={[discard]} />
          )}
          {profileSettings && (
            <SchemaParser schema={[{ ...addNewCard, disabled: !isValid }]} />
          )}
        </div>
      )}
    </div>
  );

export const CreditCard = creditCard;
